import makePssError from "./makePssError";

export const ConfigurationErrorBadQueryData = makePssError(
  "ConfigurationErrorBadQueryData"
);
export const ConfigurationErrorNoRoute = makePssError(
  "ConfigurationErrorNoRoute"
);
export const ConfigurationErrorNoModule = makePssError(
  "ConfigurationErrorNoModule"
);
export const ConfigurationErrorNoView = makePssError(
  "ConfigurationErrorNoView"
);
export const ConfigurationErrorNoFragment = makePssError(
  "ConfigurationErrorNoFragment"
);
export const ConfigurationErrorBadLink = makePssError(
  "ConfigurationErrorBadLink"
);
export const ConfigurationErrorBadModule = makePssError(
  "ConfigurationErrorBadModule"
);
export const ConfigurationErrorBadView = makePssError(
  "ConfigurationErrorBadView"
);
export const ConfigurationErrorBadFragment = makePssError(
  "ConfigurationErrorBadFragment"
);
export const ConfigurationErrorSyntax = makePssError(
  "ConfigurationErrorSyntax"
);
export const ConfigurationErrorNoReference = makePssError(
  "ConfigurationErrorNoReference"
);
export const ConfigurationErrorSchema = makePssError(
  "ConfigurationErrorSchema"
);
export const ConfigurationErrorNoContent = makePssError(
  "ConfigurationErrorNoContent"
);
export const ConfigurationErrorBadProcess = makePssError(
  "ConfigurationErrorBadProcess"
);
export const ConfigurationErrorNoTemplate = makePssError(
  "ConfigurationErrorNoTemplate"
);
export const ConfigurationErrorBadField = makePssError(
  "ConfigurationErrorBadField"
);
export const ConfigurationErrorPortalDoubleMounted = makePssError(
  "ConfigurationErrorPortalDoubleMounted"
);
export const ConfigurationErrorNoBinding = makePssError(
  "ConfigurationErrorNoBinding"
);
